import { DataConfigType } from 'routes/logged-in/collection-data-configs/CreateCollectionDataConfigRoute';
import { consumer } from '@tock/coretypes';
import { useActions } from 'utils/connect';
import LuceneDataConfigForm, {
  LuceneDataConfigValues,
  getDataConfigurationFromValues,
  luceneDataConfigEmptyState,
} from 'components/consumer-widget-data-configs/lucene-data-config/LuceneDataConfigForm';

interface Props {
  editDataConfig: consumer.ICollectionDataConfiguration;
  onCompleteOrCancel(): void;
  dataConfigType: DataConfigType;
}

const EditLuceneDataConfigForm: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  editDataConfig,
  onCompleteOrCancel,
  dataConfigType,
}) => {
  const { actions } = useActions();

  const getInitialValues = (): LuceneDataConfigValues => {
    switch (dataConfigType) {
      case 'businessLucene':
        return {
          name: editDataConfig.name || '',
          luceneQuery: editDataConfig.businessLuceneSearch?.luceneQuery || '*',
        };
      case 'experienceLucene':
        return {
          name: editDataConfig.name || '',
          luceneQuery: editDataConfig.experienceLuceneSearch?.luceneQuery || '*',
        };

      default:
        return luceneDataConfigEmptyState;
    }
  };

  const handleSubmit = (values: LuceneDataConfigValues) => {
    return actions.consumerPage
      .updateDataConfiguration(
        getDataConfigurationFromValues(values, dataConfigType, editDataConfig)
      )
      .then(() => actions.consumerPage.fetchAllCollectionDataConfigurations('ALL'))
      .then(onCompleteOrCancel);
  };

  return (
    <LuceneDataConfigForm
      dataConfigType={dataConfigType}
      onCancel={onCompleteOrCancel}
      onSubmit={handleSubmit}
      initialValues={getInitialValues()}
      editConfig={editDataConfig}
    />
  );
};

export default EditLuceneDataConfigForm;
